
export default function(o,duration){

  var s = o.sounds.main

  $(s.sound)
  .stop()
  .animate(
    {volume: 0},
    duration,
    function(){
      s.sound.pause()
    }
  )

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/util/soundStop/soundStop.js